import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Skeleton,
  Link,
  Tabs,
  Tab,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import axios from "axios";
import { a11yProps } from "../common/components/TabPanel";
import LeftLetterTemplate from "../assets/letter-temp/left-letter-template.PNG";
import CenterLetterTemplate from "../assets/letter-temp/center-letter-template.PNG";
import LeftRightLetterTemplate from "../assets/letter-temp/left-right-letter-template.PNG";
import UploadIcon from "@mui/icons-material/Upload";
import { updateEntityAddress } from "../../store/structure/actions";
import { showError, showSuccess } from "../toastify";
import LetterStyle from "./LetterStyle";

const LetterSettings = (props) => {
  const {
    showEditHeaderDialog,
    setShowEditHeaderDialog,
    entitySectorId,
    defaultTab,
    letterCustomization,
    loading,
    updateEntityAddress
  } = props;
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    costCenterId: "",
    sector: null,
    name: "",
    acronym: "",
    tinNumber: "",
    locationDistrict: null,
    locationSector: null,
    lineMinistry: null,
    unitType: null,
    entityClass: null,
    institutionEmail: "",
    institutionPhone: "",
    websiteUrl: "",
    poBox: "",
    twitterPage: "",
  });
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    handleOpenForm();
  }, []);
  const handleOpenForm = () => {
    const { entity } = letterCustomization;
    const data = {
      id: entity?.id,
      name: entity?.name,
      acronym: entity?.acronym,
      institutionEmail: entity?.institutionEmail,
      institutionPhone: entity?.institutionPhone,
      poBox: entity?.poBox,
      websiteUrl: entity?.websiteUrl,
      twitterPage: entity?.twitterPage,
      entitySectorId: entity?.entitySectorId,
      planningEntityId: entity?.planningEntityId,
    };
    setFormData({
      entityId: data.id,
      name: data.name,
      acronym: data.acronym || "",
      institutionEmail: data.institutionEmail || "",
      institutionPhone: data.institutionPhone || "",
      poBox: data.poBox || "",
      websiteUrl: data.websiteUrl || "",
      twitterPage: data.twitterPage || "",
      entitySectorId: data.entitySectorId || "",
      planningEntityId: data.planningEntityId || "",
    });
  };

  const onClose = () => {
    setShowEditHeaderDialog(false);
  };

  const pixels = {
    center: {
      minHeight: 100,
      maxHeight: 150,

      minWidth: 150,
      maxWidth: 250,
    },
    left: {
      minHeight: 100,
      maxHeight: 150,

      minWidth: 150,
      maxWidth: 250,
    },
    leftRight: {
      minHeight: 150,
      maxHeight: 200,

      minWidth: 700,
      maxWidth: 1920,
    },
  };

  const getTabByLetterPosition = () => {
    if (letterPosition === "LeftPosition") {
      return 0;
    }
    if (letterPosition === "CenteredPosition") {
      return 1;
    }
    if (letterPosition === "LeftRightPosition") {
      return 2;
    }
    return 1;
  };
  const [imageBase64, setImageBase64] = useState("");
  const [error, setError] = useState("");
  const [letterPosition, setLetterPosition] = useState(
    letterCustomization?.letterPosition || "CenteredPosition"
  );
  const [tabValue, setTabValue] = useState(getTabByLetterPosition());
  const [isDragging, setIsDragging] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [imgSize, setImgSize] = useState(pixels.center);

  const [tabValue1, setTabValue1] = useState(defaultTab);

  const handleChange1 = (event, newValue) => {
    setTabValue1(newValue);
  };
  const handleChange = (event, newValue) => {
    clearUpload();
    if (+newValue === 0) {
      setLetterPosition("LeftPosition");
      setImgSize(pixels.left);
    }
    if (+newValue === 1) {
      setLetterPosition("CenteredPosition");
      setImgSize(pixels.center);
    }
    if (+newValue === 2) {
      setLetterPosition("LeftRightPosition");
      setImgSize(pixels.leftRight);
    }
    setTabValue(newValue);
  };
  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();

  //   // Load the image as a data URL
  //   reader.onload = (e) => {
  //     const img = new Image();
  //     img.src = e.target.result;

  //     img.onload = () => {
  //       console.log(img.width, img.height);
  //       if (img.width !== 1920 || img.height !== 200) {
  //         setError("The image must be 1920 pixels wide and 200 pixels high.");
  //         setImageBase64("");
  //         return;
  //       }

  //       // Create a canvas to analyze the image
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  //       // Get pixel data
  //       const imageData = ctx.getImageData(
  //         0,
  //         0,
  //         canvas.width,
  //         canvas.height
  //       ).data;
  //       const width = img.width;
  //       const height = img.height;

  //       // Helper to check if a pixel is white or transparent
  //       const isWhiteOrTransparent = (r, g, b, a) => {
  //         // Transparent pixel?
  //         if (a === 0) return true;
  //         // Fully opaque white?
  //         return r === 255 && g === 255 && b === 255 && a === 255;
  //       };

  //       let isValidBackground = true;

  //       // 1) Check top row and bottom row
  //       for (let x = 0; x < width; x++) {
  //         // Top row pixel (y=0)
  //         let iTop = (0 * width + x) * 4;
  //         let rTop = imageData[iTop];
  //         let gTop = imageData[iTop + 1];
  //         let bTop = imageData[iTop + 2];
  //         let aTop = imageData[iTop + 3];

  //         if (!isWhiteOrTransparent(rTop, gTop, bTop, aTop)) {
  //           isValidBackground = false;
  //           break;
  //         }

  //         // Bottom row pixel (y=height-1)
  //         let iBot = ((height - 1) * width + x) * 4;
  //         let rBot = imageData[iBot];
  //         let gBot = imageData[iBot + 1];
  //         let bBot = imageData[iBot + 2];
  //         let aBot = imageData[iBot + 3];

  //         if (!isWhiteOrTransparent(rBot, gBot, bBot, aBot)) {
  //           isValidBackground = false;
  //           break;
  //         }
  //       }

  //       // 2) Check left column and right column (if still valid)
  //       if (isValidBackground) {
  //         for (let y = 0; y < height; y++) {
  //           // Left column pixel (x=0)
  //           let iLeft = (y * width + 0) * 4;
  //           let rLeft = imageData[iLeft];
  //           let gLeft = imageData[iLeft + 1];
  //           let bLeft = imageData[iLeft + 2];
  //           let aLeft = imageData[iLeft + 3];

  //           if (!isWhiteOrTransparent(rLeft, gLeft, bLeft, aLeft)) {
  //             isValidBackground = false;
  //             break;
  //           }

  //           // Right column pixel (x=width-1)
  //           let iRight = (y * width + (width - 1)) * 4;
  //           let rRight = imageData[iRight];
  //           let gRight = imageData[iRight + 1];
  //           let bRight = imageData[iRight + 2];
  //           let aRight = imageData[iRight + 3];

  //           if (!isWhiteOrTransparent(rRight, gRight, bRight, aRight)) {
  //             isValidBackground = false;
  //             break;
  //           }
  //         }
  //       }

  //       if (!isValidBackground) {
  //         setError(
  //           "The image must have a white or transparent background (at the borders)."
  //         );
  //         setImageBase64("");
  //         return;
  //       }

  //       // Convert the image to Base64
  //       const base64 = canvas.toDataURL(file.type);
  //       setImageBase64(base64);
  //       setError("");
  //     };

  //     img.onerror = () => {
  //       setError("Invalid image file.");
  //       setImageBase64("");
  //     };
  //   };

  //   reader.onerror = () => {
  //     setError("Error reading file.");
  //   };

  //   reader.readAsDataURL(file);
  // };
  const handleImageUpload = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        // console.log(img.width, img.height, imgSize);
        clearUpload();
        if (
          img.width >= imgSize.minWidth &&
          img.width <= imgSize.maxWidth &&
          img.height >= imgSize.minHeight &&
          img.height <= imgSize.maxHeight
        ) {
          // Image is within the size range

          // Create a canvas to analyze the image
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Get pixel data
          const imageData = ctx.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          ).data;
          const width = img.width;
          const height = img.height;

          // Helper to check if a pixel is white or transparent
          const isWhiteOrTransparent = (r, g, b, a) => {
            // Transparent pixel?
            if (a === 0) return true;
            // Fully opaque white?
            return r === 255 && g === 255 && b === 255 && a === 255;
          };

          let isValidBackground = true;

          // 1) Check top row and bottom row
          for (let x = 0; x < width; x++) {
            // Top row pixel (y=0)
            let iTop = (0 * width + x) * 4;
            let rTop = imageData[iTop];
            let gTop = imageData[iTop + 1];
            let bTop = imageData[iTop + 2];
            let aTop = imageData[iTop + 3];

            if (!isWhiteOrTransparent(rTop, gTop, bTop, aTop)) {
              isValidBackground = false;
              break;
            }

            // Bottom row pixel (y=height-1)
            let iBot = ((height - 1) * width + x) * 4;
            let rBot = imageData[iBot];
            let gBot = imageData[iBot + 1];
            let bBot = imageData[iBot + 2];
            let aBot = imageData[iBot + 3];

            if (!isWhiteOrTransparent(rBot, gBot, bBot, aBot)) {
              isValidBackground = false;
              break;
            }
          }

          // 2) Check left column and right column (if still valid)
          if (isValidBackground) {
            for (let y = 0; y < height; y++) {
              // Left column pixel (x=0)
              let iLeft = (y * width + 0) * 4;
              let rLeft = imageData[iLeft];
              let gLeft = imageData[iLeft + 1];
              let bLeft = imageData[iLeft + 2];
              let aLeft = imageData[iLeft + 3];

              if (!isWhiteOrTransparent(rLeft, gLeft, bLeft, aLeft)) {
                isValidBackground = false;
                break;
              }

              // Right column pixel (x=width-1)
              let iRight = (y * width + (width - 1)) * 4;
              let rRight = imageData[iRight];
              let gRight = imageData[iRight + 1];
              let bRight = imageData[iRight + 2];
              let aRight = imageData[iRight + 3];

              if (!isWhiteOrTransparent(rRight, gRight, bRight, aRight)) {
                isValidBackground = false;
                break;
              }
            }
          }

          if (!isValidBackground) {
            setError(
              "The image must have a white or transparent background (at the borders)."
            );
            setImageBase64("");
            return;
          }

          // Convert the image to Base64
          const base64 = canvas.toDataURL(file.type);
          setImageBase64(base64);
          setError("");
        } else {
          setError(
            `The image must be between ${imgSize?.minWidth}x${imgSize?.minHeight} and ${imgSize?.maxWidth}x${imgSize?.maxHeight}. The uploaded size is ${img.width}x${img.height}.`
          );
          setImageBase64("");
          return;
        }
      };

      img.onerror = () => {
        setError("Invalid image file.");
        setImageBase64("");
      };
    };
    reader.onerror = () => {
      setError("Error reading file.");
    };
    reader.readAsDataURL(file);
  };

  const clearUpload = () => {
    setImageBase64("");
    setError("");
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    handleImageUpload(file);
  };

  const onSave = () => {
    if (!!error) {
      //  setError("Try to fix error(s) to continue.");
      return;
    }
    if (!imageBase64) {
      setError("No file uploaded");
      return;
    }
    const { entity } = letterCustomization;
    const formData = new FormData();
    formData.append("entitySectorId", entitySectorId);
    formData.append("letterPosition", letterPosition);
    formData.append("planningEntityId", entity.planningEntityId);
    formData.append("imgSize", JSON.stringify(imgSize));
    formData.append("logo", imageBase64.split(",")[1]);
    submit(formData);
  };

  const submit = async (formData) => {
    try {
      setIsSaving(true);

      const { data } = await axios.post("/api/auth/letter-header", formData);
      dispatch({
        type: "SET_LETTER_CUSTOMIZATION",
        data: data,
      });
      showSuccess("Saved");
      setShowEditHeaderDialog(false);

      setIsSaving(false);
    } catch (error) {
      setIsSaving(false);
    }
  };
  const handleSubmitFooterDetails = (e) => {
    e.preventDefault();

    if (!formData.name.length) return showError("Entity name is required!");

    if (!formData.institutionEmail.length)
      return showError("Institution email is required!");

    if (!formData.institutionPhone.length)
      return showError("Institution phone is required!");

    if (!formData.poBox.length) return showError("PoBox is required!");

    if (!formData.websiteUrl.length) return showError("Website is required!");

    if (!formData.twitterPage.length) return showError("Twitter is required!");

    if (formData.institutionEmail.includes("example")) {
      return showError(
        `The institution email (${
          formData.institutionEmail || ""
        }) does not seem correct. Please update it.`
      );
    }

    if (formData.institutionPhone.includes("+25078XXXXXXX")) {
      return showError(
        `The institution phone number (${
          formData.institutionPhone || ""
        }) does not seem correct. Please update it.`
      );
    }

    const usernameRegex = /^(?!https?:\/\/).*$/;
    if (
      !!formData.twitterPage.length &&
      !usernameRegex.test(formData.twitterPage)
    ) {
      return showError("Please enter only institution Twitter/X page without any URL prefix.");
    }

    updateEntityAddress(
      formData.entityId,
      {
        ...formData,
        name: formData.name,
        acronym: formData.acronym.length > 0 ? formData.acronym : null,

        institutionEmail: formData.institutionEmail,
        institutionPhone: formData.institutionPhone,
        planningEntityId: formData.planningEntityId,

        poBox: formData.poBox,
        websiteUrl: formData.websiteUrl,
        twitterPage: formData.twitterPage,
      },
      (status) => status && onCloseEntityForm()
    );
  };

  const onCloseEntityForm = () => {
    if (!loading) {
      setFormData({
        costCenterId: "",
        sector: null,
        name: "",
        acronym: "",
        tinNumber: "",
        locationDistrict: null,
        locationSector: null,
        lineMinistry: null,
        unitType: null,
        entityClass: null,
        institutionEmail: "",
        institutionPhone: "",
        poBox: "",
        websiteUrl: "",
        twitterPage: "",
      });
      setTabValue1(1);
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showEditHeaderDialog}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle className="text-primary font-weight-bold">
          <span className="d-flex align-items-center">Settings</span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent className="pb-1" style={{ height: "100vh" }} dividers>
          <Tabs
            className="mt-2"
            value={tabValue1}
            onChange={handleChange1}
            aria-label="tabs"
            allowScrollButtonsMobile
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab className="text-capitalize" label="Header" {...a11yProps(0)} />

            <Tab className="text-capitalize" label="Footer" {...a11yProps(1)} />
            {!!letterCustomization &&
              !!letterCustomization.isHeaderLogoSettled && (
                <Tab
                  className="text-capitalize"
                  label="Other Styles"
                  {...a11yProps(2)}
                />
              )}
          </Tabs>
          {tabValue1 === 0 && (
            <>
              <form>
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex justify-content-center">
                      <Tabs
                        className="mt-2"
                        value={tabValue}
                        onChange={handleChange}
                        aria-label="tabs"
                        allowScrollButtonsMobile
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor={"success"}
                      >
                        <Tab
                          className="text-capitalize"
                          label={
                            <>
                              {" "}
                              <div
                                className="p-2"
                                style={
                                  tabValue === 0
                                    ? { border: "2px solid #1976d2" }
                                    :{ border: "2px solid rgb(38, 47, 56)" }
                                }
                              >
                                <img
                                  style={{
                                    width: tabValue === 0 ? "185px" : "165px",
                                  }}
                                  src={LeftLetterTemplate}
                                />{" "}
                                {/* <br />
                                Left Side */}
                              </div>
                            </>
                          }
                          {...a11yProps(0)}
                        />

                        <Tab
                          className="text-capitalize"
                          label={
                            <>
                              <div
                                className="p-2"
                                style={
                                  tabValue === 1
                                    ? { border: "2px solid #1976d2" }
                                    :{ border: "2px solid rgb(38, 47, 56)" }
                                }
                              >
                                <img
                                  style={{
                                    width: tabValue === 1 ? "185px" : "165px",
                                  }}
                                  src={CenterLetterTemplate}
                                />{" "}
                                {/* <br />
                                Center Side */}
                              </div>
                            </>
                          }
                          {...a11yProps(1)}
                        />
                        <Tab
                          className="text-capitalize"
                          label={
                            <>
                              <div
                                className="p-2"
                                style={
                                  tabValue === 2
                                    ? { border: "2px solid #1976d2" }
                                    :{ border: "2px solid rgb(38, 47, 56)" }
                                }
                              >
                                <img
                                  style={{
                                    width: tabValue === 2 ? "185px" : "165px",
                                  }}
                                  src={LeftRightLetterTemplate}
                                />{" "}
                                {/* <br />
                                Left Right Side */}
                              </div>
                            </>
                          }
                          {...a11yProps(2)}
                        />
                      </Tabs>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <div
                      className={
                        imageBase64
                          ? `d-flex justify-content-${
                              tabValue === 0 ? "left" : "center"
                            } `
                          : "d-flex justify-content-center"
                      }
                      // style={imageBase64 ? { border: "2px solid #1976d2" } : {}}
                    >
                      {imageBase64 ? (
                        <>
                          <div
                            className="px-2"
                            style={{
                              minWidth: imgSize.minWidth + "px",
                              maxWidth: imgSize.maxWidth + "px",
                              minHeight: imgSize.minHeight + "px",
                              maxHeight: imgSize.maxHeight + "px",
                              boxSizing: "border-box",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "5px",
                              backgroundColor: "#ffff",
                            }}
                          >
                            <img
                              src={imageBase64}
                              alt="Uploaded"
                              style={{
                                width: "calc(100% - 5px)",
                                height: "calc(100% - 5px)",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <div
                          className={` drop-zone ${
                            isDragging ? "dragging" : ""
                          }`}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleImageUpload(e.target.files[0])
                            }
                            style={{
                              display: "block",
                              width: "100%",
                              height: "100%",
                              opacity: 0,
                              position: "absolute",
                              cursor: "pointer",
                            }}
                          />
                          <p className="px-1">
                            <span
                              style={{ fontSize: tabValue !== 2 ? "12px" : "" }}
                            >
                              Drag & Drop an image here or click to select{" "}
                            </span>{" "}
                            <br />{" "}
                            <small
                              style={{
                                fontSize: "11px",
                                color: "red",
                                textAlign: "left",
                              }}
                            >
                              <ul>
                                <li>
                                  {" "}
                                  Pixels: Between {imgSize?.minWidth}x
                                  {imgSize?.minHeight} and {imgSize?.maxWidth}x
                                  {imgSize?.maxHeight}
                                </li>
                                <li> Type: At least PNG, JPG</li>
                              </ul>
                            </small>
                          </p>
                        </div>
                      )}
                    </div>
                    {imageBase64 && (
                      <div
                        style={{
                          backgroundColor: "#078ece",
                          height: "3px",
                          border: "1px solid rgb(7, 142, 206)",
                          borderRadius: "2px",
                        }}
                      ></div>
                    )}
                    {imageBase64 && (
                      <Button
                        style={{ float: "right" }}
                        className="mt-2"
                        variant="outlined"
                        color="error"
                        onClick={() => clearUpload()}
                        startIcon={<UploadIcon />}
                      >
                        Re-Upload
                      </Button>
                    )}

                    {error && (
                      <div className="col-12">
                        <p style={{ color: "red" }}>{error}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-12 d-flex justify-content-center py-3">
                    <button
                      onClick={onSave}
                      disabled={isSaving}
                      type="button"
                      className="btn btn-primary text-uppercase px-4"
                    >
                      {isSaving ? "Wait..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}
          {tabValue1 === 1 && (
            <>
              <form>
                <div className="row p-4">
                  {/* first side */}
                  <div className="col-12 col-md-12">
                    {/* ENTITY NAME */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Entity name"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            name: e.target.value.toUpperCase(),
                          });
                          setFormError(null);
                        }}
                      />
                      {formError && formError.element === "ENTITY_NAME" && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "13px" }}
                        >
                          {formError.msg}
                        </span>
                      )}
                    </div>
                  </div>
                  {/* second side */}
                  <div className="col-12 col-md-12">
                    {/* ENTITY ACRONYM */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Entity acronym"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.acronym}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            acronym: e.target.value.toUpperCase(),
                          });
                          setFormError(null);
                        }}
                      />
                      {formError && formError.element === "ENTITY_ACRONYM" && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "13px" }}
                        >
                          {formError.msg}
                        </span>
                      )}
                    </div>

                    {/* INSTITUTION EMAIL */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Institution email"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.institutionEmail}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            institutionEmail: e.target.value,
                          });
                          setFormError(null);
                        }}
                      />
                      {formError &&
                        formError.element === "INSTITUTION_EMAIL" && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formError.msg}
                          </span>
                        )}
                    </div>
                    {/* INSTITUTION WEBSITE */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Institution website link"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.websiteUrl}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            websiteUrl: e.target.value,
                          });
                          setFormError(null);
                        }}
                      />
                      {formError &&
                        formError.element === "INSTITUTION_WEBSITE" && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formError.msg}
                          </span>
                        )}
                    </div>
                    {/* INSTITUTION PHONE */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Institution phone"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.institutionPhone}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            institutionPhone: e.target.value,
                          });
                          setFormError(null);
                        }}
                      />
                      {formError &&
                        formError.element === "INSTITUTION_PHONE" && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formError.msg}
                          </span>
                        )}
                    </div>

                    {/* INSTITUTION PO.BOX */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Institution po.box"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.poBox}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            poBox: e.target.value,
                          });
                          setFormError(null);
                        }}
                      />
                      {formError &&
                        formError.element === "INSTITUTION_POBOX" && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formError.msg}
                          </span>
                        )}
                    </div>
                    {/* INSTITUTION TWITTER */}
                    <div className="mb-3">
                      <TextField
                        id="outlined-basic"
                        label="Institution Twitter/X page"
                        variant="outlined"
                        size="small"
                        className="w-100"
                        value={formData.twitterPage}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            twitterPage: e.target.value,
                          });
                          setFormError(null);
                        }}
                      />
                      {formError &&
                        formError.element === "INSTITUTION_TWITTER" && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "13px" }}
                          >
                            {formError.msg}
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-center py-3">
                    <button
                      onClick={handleSubmitFooterDetails}
                      disabled={loading}
                      type="button"
                      className="btn btn-primary text-uppercase px-4"
                    >
                      {loading ? "Wait..." : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}
          {tabValue1 === 2 && (
            <>
              <LetterStyle />
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, onWait, letterCustomization }) => {
  return {
    loading,
    onWait,
    letterCustomization,
  };
};
export default connect(mapStateToProps, {
  updateEntityAddress,
})(LetterSettings);
